import hebcal from '../services/hebcal'
import helpers from '../services/helpers'

function _registerFilters(vueFactory) {
    vueFactory.filter('duration', (sec_num) => {
        if (isNaN(sec_num)) {
            return '0:00'
        }
        let hours = Math.floor(sec_num / 3600);
        let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        let seconds = sec_num - (hours * 3600) - (minutes * 60);

        // if (hours < 10) {
        //     hours = "0" + hours;
        // }

        if (minutes < 10) {
            minutes = "0" + minutes
        }
        if (seconds < 10) {
            seconds = "0" + seconds
        }
        return `${hours}:${minutes}:${seconds}`
    })
    vueFactory.filter('formDateHeader', (date) => {
        return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear().toString().slice(-2)}`
    })

    vueFactory.filter('formDateJewishHeader', (date) => {
        const hDate = new hebcal.hebcal.HDate(date)
        const s = hDate.toString('h').split(' ')
        s[s.length - 1] = s[s.length - 1].slice(1)
        return s.join(' ')
    })

    vueFactory.filter('numToHebrewLetter', (num) => {
        if (num) {
            return helpers.numToHebrewLetter(num)
        }
        return ''
    })

    vueFactory.filter('uppercase', (str) => {
        return str.toUpperCase()
    })
}

export const registerFilters = _registerFilters

